import React from 'react'
import { EloIconProps } from '../types'

const IDEAL_ICON_STYLES = `
   [aria-label="Ideal"] .cls-1 { fill: url(#linear-gradient); }
   [aria-label="Ideal"] .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 { stroke-width: 0px; }
   [aria-label="Ideal"] .cls-2, .cls-3 { fill-rule: evenodd; }
   [aria-label="Ideal"] .cls-2, .cls-6 { fill: #232323; }
   [aria-label="Ideal"] .cls-3, .cls-8 { fill: #fff; }
   [aria-label="Ideal"] .cls-4 { fill: url(#linear-gradient-2); }
   [aria-label="Ideal"] .cls-5 { fill: #1d1c1c; }
   [aria-label="Ideal"] .cls-7 { fill: #c06; }
   [aria-label="Ideal"] .cls-9 { fill: #fff48d; }
`

export const EloIdealIcon: React.FC<EloIconProps> = ({ width = 48, height = 18.2 }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 480 182'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-label='Ideal'
  >
    <defs>
      <style dangerouslySetInnerHTML={{ __html: IDEAL_ICON_STYLES }} />
      <linearGradient
        id='linear-gradient'
        x1='352.72'
        y1='95.3'
        x2='330.2'
        y2='67.73'
        gradientTransform='translate(0 184) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='.02' stopColor='#1d1c1c' stopOpacity='0' />
        <stop offset='.68' stopColor='#1d1c1c' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-2'
        x1='313.44'
        y1='89.45'
        x2='336.52'
        y2='112.26'
        gradientTransform='translate(0 184) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='.02' stopColor='#1d1c1c' stopOpacity='0' />
        <stop offset='.68' stopColor='#1d1c1c' />
      </linearGradient>
    </defs>
    <rect className='cls-9' x='0' width='480' height='182' rx='13' ry='13' />
    <g>
      <path
        className='cls-8'
        d='M11.02,22.87v136.4c0,6.53,5.37,11.87,11.93,11.87h81.89c61.91,0,88.74-34.49,88.74-80.25S166.74,11,104.83,11H22.94c-6.56,0-11.93,5.34-11.93,11.87Z'
      />
      <path
        className='cls-7'
        d='M65.83,44.48v100.79h44.07c40.02,0,57.37-22.5,57.37-54.31s-17.36-54.07-57.37-54.07h-36.44c-4.23,0-7.63,3.44-7.63,7.6Z'
      />
      <path
        className='cls-2'
        d='M33.62,160.28h71.21c50.04,0,77.65-24.63,77.65-69.33,0-25.76-10.08-69.03-77.65-69.03H33.62c-6.32,0-11.45,5.1-11.45,11.4v115.57c0,6.29,5.13,11.4,11.45,11.4ZM25.98,33.32c0-4.21,3.4-7.6,7.63-7.6h71.21c27.55,0,73.83,8.49,73.83,65.23,0,42.26-26.24,65.53-73.83,65.53H33.62c-4.23,0-7.63-3.38-7.63-7.6V33.32Z'
      />
      <path
        className='cls-3'
        d='M87.51,76.3c-1.34-.48-2.74-.72-4.26-.72v-.06h-10.09v24.34h10.21c1.81,0,3.38-.36,4.73-.96,1.34-.66,2.45-1.5,3.33-2.58.88-1.08,1.52-2.4,1.98-3.9.41-1.5.64-3.12.64-4.92,0-2.04-.29-3.78-.82-5.28-.58-1.44-1.34-2.7-2.27-3.72-.99-.96-2.1-1.74-3.44-2.22ZM85.12,95.07c-.76.24-1.46.36-2.22.36v.06h-4.61v-15.35h3.73c1.28,0,2.33.18,3.21.54.88.36,1.58.96,2.1,1.62.52.66.93,1.56,1.17,2.52.23.96.35,2.1.35,3.3,0,1.38-.18,2.46-.52,3.42-.35.96-.82,1.68-1.34,2.28-.52.6-1.17,1.02-1.87,1.26Z'
      />
      <path
        className='cls-8'
        d='M115.11,75.59v4.5h-12.49v5.22h11.49v4.14h-11.49v5.94h12.78v4.5h-17.97v-24.34h17.68v.06Z'
      />
      <path
        className='cls-3'
        d='M141.83,99.93l-8.87-24.34h-5.42l-8.93,24.34h5.25l1.87-5.4h8.87l1.81,5.4h5.43ZM130.27,81.58l2.98,8.93h-6.12l3.09-8.93h.06Z'
      />
      <path className='cls-8' d='M150.29,75.58v19.85h11.55v4.5h-16.74v-24.34h5.19Z' />
      <path
        className='cls-6'
        d='M45.35,100.29c6.32,0,11.44-5.12,11.44-11.45s-5.12-11.45-11.44-11.45-11.44,5.12-11.44,11.45,5.12,11.45,11.44,11.45Z'
      />
      <path
        className='cls-6'
        d='M52.16,146.08c-8.86,0-15.96-7.65-15.96-17.05v-13.31c0-4.7,3.55-8.56,8.01-8.56s8.01,3.8,8.01,8.56v30.36h-.06Z'
      />
    </g>
    <g>
      <path
        className='cls-5'
        d='M405.6,91.62c0-13.38,9.52-25.57,25.96-25.57s26.03,12.2,26.03,25.57-9.52,25.57-26.03,25.57c-16.44,0-25.96-12.2-25.96-25.57ZM443.14,91.62c0-6.45-4.25-12.4-11.58-12.4s-11.58,5.96-11.58,12.4,4.32,12.41,11.58,12.41,11.58-5.96,11.58-12.41Z'
      />
      <path
        className='cls-5'
        d='M395.49,101.12c5.48-3.12,8.77-9.08,8.77-15.66,0-9.77-7.06-18.09-18.02-18.09h-23.01v48.51h14.25v-12.4h2.67l8.15,12.4h16.78l-9.59-14.76ZM383.37,92.31h-5.89v-13.72h5.96c3.84,0,6.3,3.12,6.3,6.86s-2.54,6.86-6.37,6.86Z'
      />
      <path
        className='cls-5'
        d='M298.18,67.31l-8.55,28.91-8.34-28.91h-11.35l-8.41,28.91-8.48-28.91h-15.04l17.23,48.42h12.37l8-26.36,7.93,26.36h12.44l17.23-48.42h-15.04Z'
      />
      <path
        className='cls-5'
        d='M334.78,103.91h-.03c-5.33,0-9.07-3.22-10.67-7.48h36.21c.29-1.6.44-3.24.44-4.9,0-13.34-9.49-25.51-25.95-25.52v13.14c5.36.01,9.06,3.23,10.65,7.48h-36.16c-.29,1.6-.44,3.24-.44,4.9,0,13.35,9.5,25.53,25.91,25.53h.03v-13.15Z'
      />
      <path
        className='cls-1'
        d='M334.75,117.05c.56,0,1.11-.02,1.65-.04,3.33-.17,6.36-.85,9.06-1.94,2.7-1.09,5.07-2.6,7.08-4.42,2.02-1.82,3.68-3.95,4.97-6.3,1.17-2.14,2.03-4.45,2.57-6.86h-15.09c-.31.64-.67,1.26-1.08,1.83-.56.79-1.22,1.5-1.97,2.11-.75.62-1.59,1.14-2.51,1.54-.92.4-1.93.68-3.02.83-.53.07-1.08.11-1.65.11-3.39,0-6.14-1.31-8.11-3.36l-9.81,9.92c4.36,4.03,10.41,6.57,17.91,6.57Z'
      />
      <path
        className='cls-4'
        d='M334.75,66c-13.92,0-22.87,8.76-25.26,19.56h15.04c1.8-3.72,5.34-6.42,10.22-6.42,3.89,0,6.91,1.68,8.88,4.22l9.9-10.01c-4.42-4.48-10.78-7.35-18.77-7.35Z'
      />
    </g>
    <path className='cls-5' d='M215.61,145c-1.1,0-2-.9-2-2V39c0-1.1.9-2,2-2s2,.9,2,2v104c0,1.1-.9,2-2,2Z' />
  </svg>
)
